var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "edit-attachments",
      attrs: { id: "project-docs-attachments" },
    },
    [
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.files.length && _vm.showEmptyMsg,
              expression: "!files.length && showEmptyMsg",
            },
          ],
        },
        [_vm._v("\n    " + _vm._s(_vm.emptyMsg) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.files.length > 0,
              expression: "files.length>0",
            },
          ],
          staticClass: "tender-tnc-table",
        },
        [
          _c(
            "thead",
            [
              _c("th", { staticClass: "number edit-attachments__header" }, [
                _vm._v("\n        #\n      "),
              ]),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "filename edit-attachments__header",
                  class: { pointer: _vm.sortingToggle },
                  on: {
                    click: function ($event) {
                      return _vm.sortBy("filename")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("table.header.document")) +
                      "\n        "
                  ),
                  _vm.shouldShowSortIcon("filename")
                    ? _c("HKLSortingIcon", {
                        attrs: { iconDirection: _vm.sortIconDirection },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isShowDes
                ? _c(
                    "th",
                    {
                      staticClass: "description edit-attachments__header",
                      class: { pointer: _vm.sortingToggle },
                      on: {
                        click: function ($event) {
                          return _vm.sortBy("description")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("table.header.description")) +
                          "\n        "
                      ),
                      _vm.shouldShowSortIcon("description")
                        ? _c("HKLSortingIcon", {
                            attrs: { iconDirection: _vm.sortIconDirection },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.attachmentTypes.length
                ? _vm._l(_vm.attachmentTypes, function (type) {
                    return _c(
                      "th",
                      {
                        key: type.typeName,
                        staticClass: "type edit-attachments__header",
                        class: _vm.kebabCase(type.attrName),
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(type.typeName) + "\n        "
                        ),
                      ]
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isShowUploadedDate
                ? _c(
                    "th",
                    {
                      staticClass: "uploaded-date edit-attachments__header",
                      class: { pointer: _vm.sortingToggle },
                      on: {
                        click: function ($event) {
                          return _vm.sortBy("createdAt")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("table.header.uploadedDate")) +
                          "\n        "
                      ),
                      _vm.shouldShowSortIcon("createdAt")
                        ? _c("HKLSortingIcon", {
                            attrs: { iconDirection: _vm.sortIconDirection },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canDelete ? _c("th") : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "draggable",
            {
              attrs: {
                options: { handle: ".myHandler" },
                element: "tbody",
                list: _vm.files,
              },
              on: {
                end: function ($event) {
                  return _vm.updateAllOrder()
                },
              },
            },
            [
              _vm._l(_vm.sortedFiles, function (item, index) {
                return [
                  _c(
                    "tr",
                    {
                      key: index,
                      staticClass: "set-border-top",
                      class: { myHandler: _vm.canEdit },
                    },
                    [
                      _c("td", { staticClass: "number tender-font" }, [
                        _c("span", { staticClass: "attachment-index" }, [
                          _vm._v(_vm._s(index + 1)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "filename tender-font" }, [
                        _c(
                          "a",
                          {
                            staticStyle: { "text-decoration": "underline" },
                            on: {
                              click: function ($event) {
                                return _vm.downloadFile(item.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.filename) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isShowDes
                        ? _c("td", { staticClass: "description tender-font" }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.allowChangeName[item.id],
                                    expression: "allowChangeName[item.id]",
                                  },
                                ],
                              },
                              [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.description,
                                      expression: "item.description",
                                    },
                                    { name: "autosize", rawName: "v-autosize" },
                                    {
                                      name: "checkVisibility",
                                      rawName: "v-checkVisibility",
                                      value: { refresh: true },
                                      expression: "{refresh: true}",
                                    },
                                  ],
                                  staticClass: "autosize file-upload-desc",
                                  attrs: { autofocus: "" },
                                  domProps: { value: item.description },
                                  on: {
                                    focusout: function ($event) {
                                      return _vm.updateDescription(item)
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        item,
                                        "description",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.allowChangeName[item.id],
                                    expression: "!allowChangeName[item.id]",
                                  },
                                ],
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "emphasis description-text",
                                    on: {
                                      dblclick: function ($event) {
                                        return _vm.dblClickEdit(item)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.description ||
                                            (_vm.canEdit ||
                                            _vm.showEditPencil(
                                              item,
                                              _vm.currentUser
                                            )
                                              ? _vm.$t(
                                                  "project.docs.fillDescHint"
                                                )
                                              : "")
                                        )
                                    ),
                                    _vm._v(" "),
                                    _vm.canEdit ||
                                    _vm.showEditPencil(item, _vm.currentUser)
                                      ? _c("a", {
                                          staticClass: "fa fa-pencil icon",
                                          attrs: {
                                            id: "settings-engineers-security-group-detail-name-edit",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.Vue.set(
                                                _vm.allowChangeName,
                                                item.id,
                                                true
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.attachmentTypes.length
                        ? _vm._l(_vm.attachmentTypes, function (type) {
                            return _c("td", { key: type.typeName }, [
                              _c("input", {
                                key: type.typeName + "-" + index,
                                attrs: {
                                  type: "checkbox",
                                  disabled: !_vm.canEdit,
                                },
                                domProps: {
                                  checked: !!item.metaData[type.attrName],
                                },
                                on: {
                                  change: function (e) {
                                    return _vm.updateType(e, type, item)
                                  },
                                },
                              }),
                            ])
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowUploadedDate
                        ? _c(
                            "td",
                            {
                              staticClass: "uploaded-at",
                              staticStyle: { "text-align": "right" },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.formatDate(item.createdAt)) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canDelete
                        ? _c("td", [
                            _vm.showDeleteBtn(item, index)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "file-upload-delete",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteFile(item, index)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-times fa-lg",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.canDownloadAll && _vm.files.length > 0,
              expression: "canDownloadAll && files.length > 0",
            },
          ],
          staticClass: "projects-download-all clearfix",
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn--darkblue tender-sticky-button float-left",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.downloadAll(_vm.sourceId)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.downloadString) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "float-right clearfix" },
            [_vm._t("buttons")],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }